import config from "./config.json";

export const { serverPath, appURL } = config[process.env.REACT_APP_NODE_ENV];
